import { parse } from "graphql";
import { StandardEnumOption } from "../../../data/DataManager";
import { SchemaClient } from "../../../common/GraphqlClient";
import {
  DynamoDbOperations,
  DynamoDbTables,
  Source,
} from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";



export type Reason = {
  id: string,
  configText: string,
};

export const listReasonsQuery: Source<Reason[]> = {
  graphql: parse(`
    query configurationByModelAndCreatedDate(
      $nextToken: String
    ) {
      configurationByModelAndCreatedDate(
        limit: 10000,
        nextToken: $nextToken,
        modelName: "IREDITREASON",
        sortDirection: DESC
      ) {
        nextToken
        items {
          configText
          id
        }
      }
    }
  `),
  dynamodb: {
    operation: DynamoDbOperations.QUERY,
    table: DynamoDbTables.REASONS,
    // Newest first, which is what the sortDirection on the GraphQL side asks for, and
    // needs the index sorted by createdDate rather than the table's own id sort key.
    index: "ConfigurationByModelAndCreatedDate",
    ascending: false,
    keyCondition: () => ({
      expression: "#modelName = :modelName",
      names: { "#modelName": "modelName" },
      values: { ":modelName": "IREDITREASON" },
    }),
  },
};

export const getReasons = async (client: SchemaClient): Promise<Reason[] | typeof EMPTY_VALUE> => {
  return await client.queryList(listReasonsQuery);
};


export const getAndProcessReasons = async (client: SchemaClient): Promise<StandardEnumOption<Reason>[]> => {
  const reasons = (await getReasons(client)) || [];
  return [
    ...(
      reasons.reduce((
        filteredReasons: StandardEnumOption<Reason>[],
        reason: Reason
      ) => {
        if (reason?.configText.toLowerCase() !== "other reason") {
          filteredReasons.push({
            value: {
              id: reason.id,
              configText: reason.configText
            },
            label: reason.configText
          })
        }
        return filteredReasons;
      }, [])
    ),
    {
      value: { id: "other", configText: "Other reason" },
      label: "Other reason"
    }
  ];
};